// homeActivityDetailsPref.js

const STORAGE_KEY = 'appdeck.homeActivity.showDetails.v1';

/**
 * @returns {boolean}
 */
export function readHomeActivityShowDetails() {
  if (typeof window === 'undefined' || !window?.localStorage) return false;
  try {
    return window.localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

/**
 * @param {boolean} showDetails
 */
export function writeHomeActivityShowDetails(showDetails) {
  if (typeof window === 'undefined' || !window?.localStorage) return;
  try {
    window.localStorage.setItem(STORAGE_KEY, showDetails === true ? '1' : '0');
  } catch {
    // ignore quota / private mode
  }
}
